import AxiosInstance from "./api";

export const BalanceSheetService = {
  getAll: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/balance-sheet?" + query.toString());
  },
  create: async (payload) => {
    return await AxiosInstance.post("/balance-sheet", payload);
  },
  getById: async (id) => {
    return await AxiosInstance.get("/balance-sheet/" + id);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch("/balance-sheet/" + id, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete("/balance-sheet/" + id);
  },

};
